import jQuery from 'jquery';
import Drupal from 'drupal';
import once from 'once';

/**
 * @file
 * DropdownLinks feature.
 */

(function initDropdownLinks($) {
	/**
	 * A DropdownLinks component navigates the user to a URL based on the option selected
	 */
	class DropdownLinks {
		$container: JQuery;

		$form: JQuery;

		$dropdown: JQuery;

		$button: JQuery;

		/**
		 * Store all processed DropdownLinks.
		 */
		static dropdownLinks = [] as DropdownLinks[];

		/**
		 * @param {HTMLElement} dropdownLinks
		 *   A DOM element.
		 */
		constructor(dropdownLinks: HTMLElement) {
			const $container = $(dropdownLinks);

			/**
			 * @type {jQuery}
			 */
			this.$container = $container;

			/**
			 * @type {jQuery}
			 */
			this.$form = this.$container.find('.c-dropdown-links__form');

			/**
			 * @type {jQuery}
			 */
			this.$dropdown = this.$form.find('select');

			/**
			 * @type {jQuery}
			 */
			this.$button = this.$form.find('a.c-dropdown-links__submit');

			this.updateForm();
			this.$dropdown.on( 'change', () => { this.updateForm(); } );
		}

		/**
		 * Updates the URL of the form to the corresponding destination
		 * Updates the submit button to be enabled or disabled based on the destination selected
		 */
		updateForm() {
			const val: URL | string | number | string[] | undefined = this.$dropdown.val();
			const valid = typeof(val) === 'string' && val && val.length;
      // eslint-disable-next-line no-restricted-globals
      if( typeof(val) === 'string' && new URL(val).origin !== location.origin ) {
        this.$button.addClass('external-link');
      } else {
        this.$button.removeClass('external-link');
      }
			this.$button.attr( 'href', valid ? val : '#' );
		}
	}

	// Expose constructor in the public space.
	Drupal.DropdownLinks = DropdownLinks;

	/**
	 * Process elements with the .dropbutton class on page load.
	 *
	 * @type {Drupal~behavior}
	 *
	 * @prop {Drupal~behaviorAttach} attach
	 *   Attaches dropButton behaviors.
	 */
	Drupal.behaviors.dropButton = {
		attach(context) {
			const dropdownLinks = once('dropdownlinks', '.c-dropdown-links', context);
			if (dropdownLinks.length) {
				const il = dropdownLinks.length;
				for (let i = 0; i < il; i += 1) {
					DropdownLinks.dropdownLinks.push(
						new DropdownLinks(dropdownLinks[i])
					);
				}
			}
		},
	};
})(jQuery);
